export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Latin1-160c450b41a6dfc1bebee1e90adebf49.woff2";